var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-291.539q13.731 0 23.019-9.289 9.288-9.288 9.288-23.018 0-13.731-9.288-23.019-9.288-9.289-23.019-9.289-13.731 0-23.019 9.289-9.288 9.288-9.288 23.019 0 13.73 9.288 23.018 9.288 9.289 23.019 9.289Zm.013-139.23q12.756 0 21.371-8.624 8.615-8.625 8.615-21.375v-181.54q0-12.75-8.628-21.374-8.629-8.625-21.384-8.625-12.756 0-21.371 8.625-8.615 8.624-8.615 21.374v181.54q0 12.75 8.628 21.375 8.629 8.624 21.384 8.624ZM368.385-140.001q-14.632 0-27.893-5.616-13.261-5.615-23.107-15.461L161.078-317.385q-9.846-9.846-15.461-23.107-5.616-13.261-5.616-27.893v-223.23q0-14.632 5.616-27.893 5.615-13.261 15.461-23.107l156.307-156.307q9.846-9.846 23.107-15.461 13.261-5.616 27.893-5.616h223.23q14.632 0 27.893 5.616 13.261 5.615 23.107 15.461l156.307 156.307q9.846 9.846 15.461 23.107 5.616 13.261 5.616 27.893v223.23q0 14.632-5.616 27.893-5.615 13.261-15.461 23.107L642.615-161.078q-9.846 9.846-23.107 15.461-13.261 5.616-27.893 5.616h-223.23ZM364-200h232l164-164v-232L596-760H364L200-596v232l164 164Zm116-280Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.43e3242d01b0414b90078445a82a3d63.svg";
export { ForwardRef as ReactComponent };